import { TableCell } from '@/components/ui/table';
import { formatPercentage } from '@/utils/format/number';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type AvgContainerTagCellProps = {
  row: UnitOverviewRow;
};

export function AvgContainerTagCell({ row }: AvgContainerTagCellProps) {
  return (
    <TableCell narrow justify="left">
      {row.avgContainerTag ? formatPercentage(row.avgContainerTag, 0, 5) : '-'}
    </TableCell>
  );
}
